/**
 * Utilitário para rastreamento de eventos do Facebook Pixel
 * ID do Pixel: 1899065511041406
 */
/* global fbq */

/**
 * Rastreia um evento customizado no Facebook Pixel
 * @param {string} eventName - Nome do evento (ex: 'Purchase', 'SignUp', 'Lead')
 * @param {object} eventData - Dados adicionais do evento (opcional)
 */
export const trackFacebookEvent = (eventName, eventData = {}) => {
  if (typeof window !== 'undefined' && typeof fbq === 'function') {
    fbq('track', eventName, eventData);
  } else {
    console.warn('Facebook Pixel não está disponível');
  }
};

/**
 * Rastreia o evento de registro de novo usuário
 */
export const trackSignUp = () => {
  trackFacebookEvent('SignUp');
};

/**
 * Rastreia o evento de assinatura do plano mensal
 */
export const trackMonthlySubscription = () => {
  trackFacebookEvent('Subscribe', {
    value: 29.90,
    currency: 'BRL',
    predicted_ltv: 29.90,
    subscription_period: 'monthly'
  });
};

/**
 * Rastreia o evento de assinatura do plano anual
 */
export const trackAnnualSubscription = () => {
  trackFacebookEvent('Subscribe', {
    value: 197.90,
    currency: 'BRL',
    predicted_ltv: 197.90,
    subscription_period: 'annual'
  });
};
